var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_348)",
    filter: "url(#filter0_d_1_348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9683 1.68422C19.9557 1.62517 19.9276 1.57057 19.8868 1.52608C19.846 1.48158 19.794 1.44883 19.7363 1.43122C19.526 1.3893 19.3084 1.40484 19.1063 1.47622C19.1063 1.47622 5.08725 6.51422 4.28625 7.07222C4.11425 7.19322 4.05625 7.26222 4.02725 7.34422C3.88925 7.74422 4.32025 7.91722 4.32025 7.91722L7.93325 9.09422C7.99426 9.10522 8.05701 9.10145 8.11625 9.08322C8.93825 8.56422 16.3863 3.86122 16.8163 3.70322C16.8843 3.68322 16.9343 3.70322 16.9163 3.75222C16.7443 4.35222 10.3103 10.0712 10.2753 10.1062C10.2582 10.1205 10.2448 10.1387 10.2363 10.1592C10.2277 10.1798 10.2243 10.2021 10.2263 10.2242L9.88925 13.7522C9.88925 13.7522 9.74725 14.8522 10.8453 13.7522C11.6243 12.9732 12.3723 12.3272 12.7453 12.0142C13.9873 12.8722 15.3243 13.8202 15.9013 14.3142C15.9979 14.4083 16.1125 14.4819 16.2383 14.5305C16.3641 14.5792 16.4985 14.6018 16.6333 14.5972C16.7992 14.5767 16.955 14.5062 17.0801 14.3952C17.2051 14.2841 17.2934 14.1376 17.3333 13.9752C17.3333 13.9752 19.8943 3.70022 19.9793 2.31722C19.9873 2.18222 20.0003 2.10022 20.0003 2.00022C20.0039 1.89392 19.9931 1.78762 19.9683 1.68422Z",
    fill: "#626377"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_348",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.3f392151caebae229730324065843d7a.svg";
export { ForwardRef as ReactComponent };